module.exports = __webpack_public_path__ + "static/media/headsup.e5690f32.svg";